import { DateTime } from 'luxon';
import type {
  ReservationFormMainContext,
  ReservationFormMainEvent,
} from '../machines/reservationFormMain.types';
import { getTripsFromMachines } from './getTripsFromMachines';
import type { TripSegmentValues } from '../schema/reservationForm.schema';

function hasValidAppointmentDateTime(trip: TripSegmentValues): boolean {
  return (
    trip.appointmentDateTime instanceof DateTime &&
    trip.appointmentDateTime.isValid
  );
}

function hasValidAppointmentDate(trip: TripSegmentValues): boolean {
  return (
    Boolean(trip.appointmentDate?.trim()) &&
    DateTime.fromISO(trip.appointmentDate).isValid
  );
}

function shouldValidateReservation(
  context: ReservationFormMainContext,
  event?: ReservationFormMainEvent,
): boolean {
  // Ensure that we have at least the data construct required for a trip leg
  const trips = getTripsFromMachines(context);
  if (trips.length === 0) {
    return false;
  }
  const first = trips[0];
  if (!first) {
    return false;
  }

  // Pick date & time: appointment datetime must be set.
  // Call when ready: date-only is enough, but a leftover datetime from the
  // other radio option should also allow /validate (same gate as picking a time). See: F1V2-6286
  return first.isWillCall
    ? hasValidAppointmentDate(first) || hasValidAppointmentDateTime(first)
    : hasValidAppointmentDateTime(first);
}

export { shouldValidateReservation };
